import type { ComplianceStatus, MatterPhase, MatterResult } from './types';

// Case 360° lifecycle phase badge palette (solid, status-badge style) — one
// distinct color per phase. Mirrors the dot palette in MattersFilterBar.
export const getMatterPhaseColor = (phase: MatterPhase | undefined): string => {
  switch (phase) {
    case 'INTAKE':
      return 'bg-blue-500 text-white';
    case 'PROVISIONAL_OPEN':
      return 'bg-orange-500 text-white';
    case 'PLANNING':
      return 'bg-sky-500 text-white';
    case 'EXECUTION':
      return 'bg-amber-500 text-white';
    case 'REVIEW':
      return 'bg-violet-500 text-white';
    case 'CLOSED':
      return 'bg-gray-500 text-white';
    case 'SUSPENDED':
      return 'bg-slate-400 text-white';
    default:
      return 'bg-gray-300';
  }
};

// The legacy Matter.status badge palette was removed — the lifecycle is
// phase-keyed (Case 360°); only the result palette remains.
export const getMatterResultColor = (result: MatterResult | undefined): string => {
  switch (result) {
    case 'WIN':
      return 'bg-green-600 text-white';
    case 'LOSE':
      return 'bg-red-400 text-white';
    case 'SETTLED':
      return 'bg-yellow-400 text-white';
    case 'CANCELLED':
      return 'bg-orange-400 text-white';
    default:
      return 'bg-gray-300';
  }
};

// Compliance decision badge palette (Stage 6 ComplianceStatus).
export const getComplianceStatusColor = (
  compliance: ComplianceStatus | undefined,
): string => {
  switch (compliance) {
    case 'PASSED':
      return 'bg-green-600 text-white';
    case 'PASSED_WITH_CONDITIONS':
      return 'bg-lime-500 text-white';
    case 'PENDING':
      return 'bg-yellow-400 text-white';
    case 'FAILED':
      return 'bg-red-500 text-white';
    case 'BYPASSED':
      return 'bg-orange-500 text-white';
    default:
      return 'bg-gray-300';
  }
};
